import { useSidebar } from '@/lib/context/SidebarContext';
import { useLocation } from 'react-router-dom';
import { NotificationsPanel } from '@/components/notifications/NotificationsPanel';
import { ThemeToggle } from '@/components/common/ThemeToggle';

const PAGE_NAMES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/jobs': 'Jobs',
  '/calendar': 'Calendar',
  '/clients': 'Clients',
  '/employees': 'Employees',
  '/timesheets': 'Timesheet Approvals',
  '/catalog': 'Catalog',
  '/documents': 'Documents',
  '/quotes': 'Quotes',
  '/invoices': 'Invoices',
  '/reports': 'Reports',
  '/vendors': 'Vendors',
  '/settings': 'Settings',
};

interface HeaderProps {
  onSearchOpen?: () => void;
}

export const Header = ({ onSearchOpen }: HeaderProps) => {
  const { openMobileSidebar } = useSidebar();
  const location = useLocation();

  const pageName = Object.entries(PAGE_NAMES).find(([path]) =>
    location.pathname === path || location.pathname.startsWith(path + '/')
  )?.[1] ?? 'OchrePoint';

  return (
    <header
      className="sticky top-0 z-30 w-full bg-white/80 backdrop-blur-xl border-b border-gray-200/80 md:hidden"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="relative flex h-14 items-center px-2">
        <button
          onClick={openMobileSidebar}
          className="absolute left-1.5 flex h-11 w-11 items-center justify-center rounded-full text-gray-600 hover:bg-primary/10 active:bg-primary/20 active:scale-90 transition"
          aria-label="Open navigation"
        >
          <span className="material-symbols-outlined">menu</span>
        </button>
        <div className="flex w-full items-center justify-center gap-2 px-14">
          <span className="material-symbols-outlined text-primary text-lg leading-none">construction</span>
          <span className="truncate text-[15px] font-bold text-gray-900">{pageName}</span>
        </div>
        <div className="absolute right-1.5 flex items-center gap-0.5">
          {onSearchOpen && (
            <button
              onClick={onSearchOpen}
              className="flex h-11 w-11 items-center justify-center rounded-full text-gray-500 hover:text-gray-800 hover:bg-gray-100 active:scale-90 transition"
              title="Search (⌘K)"
              aria-label="Search"
            >
              <span className="material-symbols-outlined text-xl">search</span>
            </button>
          )}
          <ThemeToggle />
          <NotificationsPanel />
        </div>
      </div>
    </header>
  );
};
